import React from 'react';
import TagInfo from '../../../../../../components/TagInfo';
import { IconWarningBlue } from '../../../../../../components/IconWarningBlue';

export const TherapyProductInfo: React.FC = () => {
  return (
    <TagInfo
      icon={<IconWarningBlue />}
      info="Para realizar o procedimento, preencha o cadastro no link enviado para seu e-mail. Nele você deverá inserir os dados da fonte pagadora (particular ou convênio) e adicionar o pedido médico da Sangria Terapêutica."
    />
  );
};
